import {
    ConversationConversationTypeEnum,
    Conversation,
} from '@calm/evexia-web-sdk';
import { useAiConversation } from '../use-ai-conversations';

interface UseLatestConversationIdParams {
    conversationType: ConversationConversationTypeEnum;
}

export function useLatestConversationId({
    conversationType,
}: UseLatestConversationIdParams) {
    const { conversations, ...otherProps } = useAiConversation({
        conversationType,
    });

    const conversationList = conversations ?? [];
    const latest = conversationList.reduce(
        (latest: Conversation | undefined, current: Conversation) =>
            !latest || new Date(current.createdAt) > new Date(latest.createdAt)
                ? current
                : latest,
        undefined
    );

    return {
        conversationId: latest?.id,
        ...otherProps,
    };
}
